function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 26,
  stroke: "currentColor",
  strokeWidth: 5,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 24.5c0-4.8 3.4-8 7.5-8s7.5 3.4 7.5 8c0 3.8-2.6 5.8-4.8 7.6-2.2 1.8-3.7 3.2-3.7 6.2",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 46.5,
  r: 3.2,
  fill: "currentColor"
});

var SvgHelpOutline = function SvgHelpOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help_outline.0f80f9cf.svg";
export { ForwardRef as ReactComponent };